import { Tabs, TabsList, TabsTrigger } from "@/components/ui";
import { FileText, FolderOpen, List } from "lucide-react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useSetPageTitle } from "../../context/PageTitleContext";
import ArchivioCapitoli from "./capitoli";
import ArchivioFiles from "./files";
import ArchivioMateriale from "./materiale";

const ArchivioRoutes = () => {
  useSetPageTitle("Il mio archivio", "Gestisci i tuoi documenti e materiali didattici");
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab = location.pathname.split("/").pop() || "files";
  const activeTab = ["files", "chapters", "materials"].includes(currentTab)
    ? currentTab
    : "files";

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6 lg:px-8">
      <Tabs
        value={activeTab}
        onValueChange={(val) => navigate("/repository/" + val)}
        className="mb-6"
      >
        <TabsList className="h-auto gap-2 bg-transparent p-0">
          <TabsTrigger
            value="files"
            className="gap-2 rounded-full border border-[var(--color-mockup-border)] bg-surface px-5 py-2.5 text-xs font-bold shadow-sm data-[state=active]:border-transparent data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow-md"
          >
            <FileText className="h-4 w-4" />
            <span>Documenti</span>
          </TabsTrigger>
          <TabsTrigger
            value="chapters"
            className="gap-2 rounded-full border border-[var(--color-mockup-border)] bg-surface px-5 py-2.5 text-xs font-bold shadow-sm data-[state=active]:border-transparent data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow-md"
          >
            <List className="h-4 w-4" />
            <span>Capitoli</span>
          </TabsTrigger>
          <TabsTrigger
            value="materials"
            className="gap-2 rounded-full border border-[var(--color-mockup-border)] bg-surface px-5 py-2.5 text-xs font-bold shadow-sm data-[state=active]:border-transparent data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow-md"
          >
            <FolderOpen className="h-4 w-4" />
            <span>Materiale classi</span>
          </TabsTrigger>
        </TabsList>
      </Tabs>

      <Routes>
        <Route path="materials" element={<ArchivioMateriale />} />
        <Route path="files" element={<ArchivioFiles />} />
        <Route path="chapters" element={<ArchivioCapitoli />} />
        <Route index element={<Navigate replace to="files" />} />
      </Routes>
    </div>
  );
};

export default ArchivioRoutes;
